export const brown = '#9e7666';
export const brown_light = '#a68c58';
export const bg_brown = '#fdf0e3';
export const bg_brown_light = '#fef8f4';
export const bg_grey = '#f2ece8';
export const grey = '#606060';
export const success = '#55b37e';
export const success2 = '#369094';
export const mute = '#b2b2b2';
